/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductDto } from '../../models/product-dto';

export interface UserProductControllerFindById$Params {
  id: string;
}

export function userProductControllerFindById(http: HttpClient, rootUrl: string, params: UserProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
  const rb = new RequestBuilder(rootUrl, userProductControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductDto>;
    })
  );
}

userProductControllerFindById.PATH = '/api/user-product/{id}';
